import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)

Vue.use(Router)

// vue3 router捕获异常
const originalRouter = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalRouter.call(this, location).catch(err => err)
}

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '*',
    component: _import('layout/index'),
    redirect: '/home',
    name: 'home',
    hidden: true,
    children: [{
      path: 'home',
      component: _import('general/index')
    }]
  }/*,
  {
    path: '/demo',
    name: 'demo',
    component: _import('contentManage/pageIndexManage/index'),
    hidden: true
  }*/
]

export default new Router({
  // mode: 'history', 
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js